/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'rotate-right': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M13.815 6.634a.54.54 0 0 0 .821.697l2.702-2.657.064-.075a.54.54 0 0 0-.057-.69l-2.703-2.747-.074-.064a.54.54 0 0 0-.69.057l-.063.074a.54.54 0 0 0 .057.69l1.804 1.837H4.997c-1.514 0-2.741 1.158-2.741 2.586v12.14c0 .286.245.518.548.518.303 0 .548-.232.548-.517V6.343c0-.858.737-1.553 1.645-1.553h10.681l-1.8 1.77-.063.074z" _fill="#0D204A"/>'
  }
})
